const path = '/img/solutions/GD';

export const BANNER = {
  title: '广电/传媒行业解决方案',
  description:
    '依托丰富且深厚的音视频处理能力，针对广电/传媒客户提供“端、网、云”一站式服务，通过对内容采集生产、智能媒资、分发调度、多端播放等多环节的深度理解，打造匹配该行业迅速转型和升级的全媒体方案',
  buttonText: '立即咨询',
  backgroundImg: `${path}/banner.webp`,
  backgroundImgMobile: `${path}/bannerMobile.webp`,
  docText: '产品文档',
};

export const ARCHITECTURE = {
  title: '方案架构',
  picUrl: `${path}/architecture.webp`,
};

export const NAV = ['方案架构', '行业挑战', '方案优势', '具体方案场景'];

export const ADVANTAGES = {
  title: '行业挑战',
  details: [
    {
      title: '人工依赖高，产量低，效果单一',
      content:
        '传统内容生产对人工依赖较重，无法满足实时热点及时发布、海量视频生产等场景对生产效率的要求',
      iconUrl: `${path}/icon1.webp`,
    },
    {
      title: '媒资融合难',
      content:
        '受限于独立云架构，文件内容无法共享，不利于快速实现媒资融合，多端互通',
      iconUrl: `${path}/icon2.webp`,
    },
    {
      title: '海量媒资难以挖掘',
      content:
        '传统行业媒资量级大、价值高，但缺少与媒资编目匹配的类目及标签体系，无法有效建立内容关系网',
      iconUrl: `${path}/icon3.webp`,
    },
  ],
};

export const PROJECTADVANTAGES = {
  title: '方案优势',
  details: [
    {
      title: '智能、丰富的内容生产能力',
      content:
        '专业的剪辑能力与丰富的美颜特效，一键成片、智能横竖屏转码等能力，在降低创作门槛的同时，带来更趋近于当下流行的消费内容形态，提升传播效果',
      iconUrl: `${path}/icon11.webp`,
    },
    {
      title: '超高清技术加持',
      content: '降低超高清节目的制作门槛，提升超高清视频的制作效率',
      iconUrl: `${path}/icon12.webp`,
    },
    {
      title: `自研H.265、KVC转码技术`,
      content:
        '传媒行业媒资体量大，存储成本高。自研H.265和KVC转码技术相比行业H.265压缩率可提升30%～60%，大幅度降低存储成本，节省带宽用量',
      iconUrl: `${path}/icon13.webp`,
    },
    {
      title: `智能媒资管理`,
      content:
        '广电媒资题材广、内容多，编目成本高。通过在视频、图像、语音识别及多模检索深厚积累，有效解决传统媒资管理成本高的问题，提升检索效率和准确率',
      iconUrl: `${path}/icon14.webp`,
    },
    {
      title: `融合CDN助力终端消费`,
      content:
        '融合主流CDN分发资源，基于智能调度大脑，以质量优先的原则进行选择，最大程度保障用户播放质量',
      iconUrl: `${path}/icon15.webp`,
    },
    {
      title: `运营生态联动`,
      content:
        '结合快手自有内容生态、用户生态和运营生态，增加内容分发和曝光的渠道，共同策划活动，帮助客户提升影响力',
      iconUrl: `${path}/icon16.webp`,
    },
  ],
};

export const PROJECTSCENARIOS = {
  title: '具体方案场景',
  items: [
    {
      title: '智能老片修复',
      subTitle:
        '针对传媒行业海量、高价值老旧媒资，快手推出智能老片修复解决方案。该方案通过智能算法决策，灵活调用 SR、FRUC、色彩修复、音频增强等多种媒体处理能力，使经典重获新生，老片焕发新色',
      picUrl: `${path}/修复.webp`,
    },
    {
      title: '超清智能生产/处理',
      subTitle:
        '5G+4K 智能生产解决方案，面向新媒体报道提供移动端和云端智能生产能力，降低了融媒体时代各类创作者新闻生产门槛。针对重大直播活动，通过云端生产平台的直播拆条、精彩片段等功能，快速生成发布实时热点素材，极大的提升新闻稿件的发布速度，解决了传统稿件落后于实际活动的痛点。云端智能生产服务可对海量媒资再次进行智能创作，增加了媒资的丰富度。SR、HDR、画面修复等行业领先的技术，实现视频4K臻享画质，满足不同终端用户高品质体验',
      picUrl: `${path}/HD.webp`,
    },
    {
      title: '智慧媒资管理',
      subTitle:
        '智慧媒资管理解决方案主要面向广电传媒行业领域，提供媒资入库、审核管理、检索查询、媒资存储等业务需求。该系统充分利用AI内容理解技术和大数据统计分析能力，实现对媒资的智能管理、科学分发、盘活媒资，解决广电行业 “编目成本高”、“内容搜索难”、“业务收益小”的难题，为客户提供易用、高效的媒资产品',
      picUrl: `${path}/管理.webp`,
    },
    {
      title: '内容审核',
      subTitle:
        '内容审核解决方案支持视频、直播内容审核，涵盖安全、质量检测，采用AI多模态融合算法对媒资内容中的物品、内容、音视频质量、文字进行安全审核，降低不良曝光，节省审核成本，提高放行效率，使新媒体时代人人都是新闻生产者，共创安全、健康的媒体环境',
      picUrl: `${path}/审核.webp`,
    },
    {
      title: '智能编目检索',
      subTitle:
        '智能编目检索解决方案支持视频内容智能编目及检索，利用视频、图像、语音识别及多模检索能力有效解决传统媒资管理成本高、效率低的问题， 实现对媒资的智能化编目，提升检索效率，充分挖掘媒资的价值',
      picUrl: `${path}/检索.webp`,
    },
    {
      title: '超高清直播',
      subTitle:
        '快手超高清直播解决方案主要面向传媒直播活动、慢直播等直播业务，快手服务智能决策使用SR、FRUC能力动态调整视频画质，实现全链路支持4K超高清画质。“云导播-云录制-云媒资-云创作”四云一体，并行实现“监控、存储、创作”等能力',
      picUrl: `${path}/直播.webp`,
    },
  ],
};
